import { structure } from '@dofleini/location';
import { Select } from 'antd';
import compose from 'lodash/fp/compose';
import filter from 'lodash/fp/filter';
import map from 'lodash/fp/map';
import includes from 'lodash/includes';
import isEmpty from 'lodash/isEmpty';
import PropTypes from 'prop-types';
import React, { useMemo } from 'react';

import useCheckUpdated from '../../../hooks/useCheckUpdated';
import { useSelectSearchProps } from '../hooks';

const { MUNICIPALITIES } = structure;

const MunicipalitiesField = ({ related, filterBy, ...props }) => {
  const options = useMemo(
    () =>
      compose(
        map(({ code, name }) => ({ label: name, value: code })),
        filter(
          ({ code }) =>
            !filterBy || isEmpty(filterBy) || includes(filterBy, code)
        )
      )(MUNICIPALITIES[related]),
    [related, filterBy]
  );
  
  useCheckUpdated(() => {
    props.onChange();
  }, related);
  
  const _props = useSelectSearchProps(options, props?.value);
  
  return <Select allowClear {..._props} {...props} disabled={!related}/>;
};

MunicipalitiesField.propTypes = {
  filterBy: PropTypes.array,
  related: PropTypes.any,
  value: PropTypes.any,
  onChange: PropTypes.func,
  props: PropTypes.object,
};

export default MunicipalitiesField;
